import React from "react";
import { PeekBox, PeekChip, PeekList, PeekListItem, PeekListItemText, PeekStack, PeekTooltip, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
const MultiTooltip = ({ values }) => {
    return (React.createElement(PeekList, { disablePadding: true }, values === null || values === void 0 ? void 0 : values.map((value) => {
        return (React.createElement(PeekListItem, { disablePadding: true, key: value === null || value === void 0 ? void 0 : value._id },
            React.createElement(PeekListItemText, { primary: React.createElement(PeekTypography, null,
                    "\u2022 ", value === null || value === void 0 ? void 0 :
                    value.name), primaryTypographyProps: { variant: "body1" } })));
    })));
};
export const MultiValuesChip = ({ values }) => {
    var _a, _b, _c;
    const theme = useTheme();
    if (!values)
        return;
    const isSoloInfo = (values === null || values === void 0 ? void 0 : values.length) <= 1;
    const label = (React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(0.5), width: theme.spacing(10) }, isSoloInfo ? (React.createElement(PeekTypography, { maxWidth: theme.spacing(10), overflow: "hidden", textOverflow: "ellipsis" }, ((_a = values[0]) === null || _a === void 0 ? void 0 : _a.name) || "-")) : (React.createElement(React.Fragment, null,
        React.createElement(PeekTypography, { maxWidth: theme.spacing(10), overflow: "hidden", textOverflow: "ellipsis" }, `${((_b = values[0]) === null || _b === void 0 ? void 0 : _b.name) || "-"}, ${((_c = values[1]) === null || _c === void 0 ? void 0 : _c.name) ? values[1].name.slice(0, 2) + "..." : "-"}`),
        React.createElement(PeekTypography, null,
            "+",
            (values === null || values === void 0 ? void 0 : values.length) - 1)))));
    return (React.createElement(PeekTooltip, { title: React.createElement(MultiTooltip, { values: values }) },
        React.createElement(PeekBox, null,
            React.createElement(PeekChip, { variant: "filled", label: label, sx: {
                    "&.MuiChip-filledDefault": { backgroundColor: "primary.contrastText" },
                } }))));
};
export default MultiValuesChip;
